import React from "react";
import { PausedTrafficList } from "@/components/analytics/PausedTrafficList";

export default function PausedTraffic() {
  return (
    <div data-testid="paused-traffic-page">
      <div className="mb-6">
        <div className="label-mono">Analytics</div>
        <h1 className="font-chivo text-4xl font-black uppercase leading-none tracking-tighter md:text-5xl">Paused traffic</h1>
        <div className="mt-1 text-sm text-zinc-600">Every affiliate and funnel paused from the buyer rejections report, who paused it and when.</div>
      </div>
      <PausedTrafficList />
    </div>
  );
}
